import React, { useState } from "react"
import { Link, useHistory, useLocation } from "react-router-dom"
import { GoogleLogin } from "@react-oauth/google"
import Back from "../common/Back"
import img from "../images/about.jpg"
import { useAuth } from "../../context/AuthContext"
import { authFetch } from "../../lib/api"
import "./auth.css"

function getRedirectPath(search) {
  const params = new URLSearchParams(search)
  const r = params.get("redirect")
  if (r && typeof r === "string" && r.startsWith("/") && !r.startsWith("//")) return r
  return null
}

const SignIn = () => {
  const history = useHistory()
  const location = useLocation()
  const { login } = useAuth()
  const redirectTo = getRedirectPath(location.search)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError("")
    setLoading(true)
    try {
      const res = await authFetch("/api/auth/signin", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Sign in failed")
        return
      }
      login(data.token, data.user)
      history.push(redirectTo || "/")
    } catch (err) {
      setError("Something went wrong. Please try again.")
    } finally {
      setLoading(false)
    }
  }

  const handleGoogleSuccess = async (credentialResponse) => {
    const idToken = credentialResponse.credential
    if (!idToken) {
      setError("Google sign-in did not return a credential")
      return
    }
    setLoading(true)
    setError("")
    try {
      const res = await authFetch("/api/auth/google", {
        method: "POST",
        body: JSON.stringify({ idToken }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.error || "Google sign-in failed")
        return
      }
      login(data.token, data.user)
      history.push(redirectTo || "/")
    } catch (err) {
      setError("Google sign-in failed")
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className='auth-section'>
      <Back name='Sign In' title='Welcome back to Vista Hill Houses' cover={img} />
      <div className='auth-page'>
        <div className='container'>
          <div className='auth-card'>
            <h1 className='auth-card__title'>Sign in</h1>
            <p className='auth-card__subtitle'>Enter your details to access your account</p>

            {error && <p className='auth-error'>{error}</p>}

            <div className='auth-google-wrap'>
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => setError("Google sign-in was cancelled or failed")}
                useOneTap={false}
                theme='outline'
                size='large'
                text='signin_with'
                shape='rectangular'
              />
            </div>

            <div className='auth-divider'>or continue with email</div>

            <form onSubmit={handleSubmit} className='auth-form'>
              <label htmlFor='signin-email'>Email</label>
              <input
                id='signin-email'
                type='email'
                placeholder='you@example.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <label htmlFor='signin-password'>Password</label>
              <input
                id='signin-password'
                type='password'
                placeholder='••••••••'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <div className='auth-link'>
                <Link to='/forgot-password'>Forgot password?</Link>
              </div>
              <button type='submit' className='auth-form__submit' disabled={loading}>
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>

            <div className='auth-footer'>
              Don't have an account? <Link to='/signup'>Sign up</Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SignIn
